import { convertUserToDraft, UserProfile } from "@modules/auth/userProfileTypes"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import {
  convertUserProfileFromFormikToUserProfileDraft,
  convertUserToFormik,
  getValidationSchema,
  UserFormikType,
} from "@modules/profile/myProfile/profileFormikType"
import { useToast } from "@modules/ui/components/huToast"
import { useUnit } from "@modules/utils/hooks/useUnit"
import { LoggerType } from "@modules/utils/loggerUtils"
import { useFormik } from "formik"
import { useMemo, useState } from "react"

export const useProfileFormik = (user: UserProfile) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [activeIndex, setActiveIndex] = useState(0)

  const { userProfileService, browserProfileService } = useServicesContext()
  const userDraft = convertUserToDraft(user)
  const toast = useToast()
  const unit = useUnit()

  const validationSchema = useMemo(() => getValidationSchema(activeIndex), [activeIndex])

  const formik = useFormik<UserFormikType>({
    initialValues: convertUserToFormik(userDraft, unit),
    validationSchema,
    onSubmit: async () => {
      try {
        setIsSubmitting(true)
        browserProfileService.setUnit(formik.values.unit)
        await userProfileService.update(convertUserProfileFromFormikToUserProfileDraft(formik.values))
        toast.show({
          severity: "success",
          summary: word("profile.page.toast.success"),
        })
      } catch (e: any) {
        console.error(LoggerType.Profile + "update profile", e)
        toast.show({ severity: "error", summary: "Error", detail: e.message })
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  return { formik, isSubmitting, activeIndex, setActiveIndex }
}
